const STORAGE_KEY = 'page_view_as';

export const getPageViewAsSelection = () => {
  try {
    const storedValue = window.sessionStorage.getItem(STORAGE_KEY);
    if (!storedValue) { return {}; }

    try {
      return JSON.parse(storedValue);
    } catch {
      return { value: storedValue };
    }
  } catch {
    return {};
  }
};

export const storePageViewAsSelection = (value, navigationItemId) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ value, navigationItemId }));
  } catch {
    // The selection still works when browser storage is unavailable.
  }
};

export const storePageViewAsNavigationItem = (navigationItemId) => {
  const { value } = getPageViewAsSelection();
  storePageViewAsSelection(value, navigationItemId);
};
